import { createLazyFileRoute } from "@tanstack/react-router";

import { ClientsPage } from "@/features/admin/routes/Clients";

export const Route = createLazyFileRoute("/_auth/admin/clients/")({
  component: ClientsPage,
});
